import React, { Component } from 'react';
import './FormLoading.scss';

interface Props {
  loadingText?: string;
  subText?: string;
}

class FormLoading extends Component<Props> {

  render() {
    const { loadingText, subText } = this.props;

    return (
      <div id="center">
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <p>{loadingText || "Please wait while the app is loading …"}</p>
        <p>{subText || "This can take up to 30 seconds."}</p>
      </div>
    );
  }
}

export default (FormLoading);
